var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCheckActive = function SvgCheckActive(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_529_351)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9968 4.77555C18.1739 4.66897 18.3855 4.63517 18.5871 4.68123C18.7887 4.7273 18.9645 4.84966 19.0778 5.02262L19.8694 6.23001C19.9726 6.38774 20.0168 6.57685 19.9941 6.76397C19.9714 6.95109 19.8834 7.12418 19.7455 7.25269L19.7431 7.25589L19.7319 7.26629L19.6863 7.30867L19.5064 7.48058C18.5109 8.44617 17.5456 9.44241 16.6119 10.4679C14.8552 12.3997 12.769 14.928 11.3649 17.3812C10.9731 18.0656 10.016 18.2127 9.4483 17.6218L4.26293 12.2342C4.18862 12.1569 4.13059 12.0655 4.09231 11.9654C4.05402 11.8653 4.03625 11.7585 4.04005 11.6514C4.04386 11.5443 4.06916 11.4391 4.11445 11.3419C4.15974 11.2448 4.2241 11.1577 4.30371 11.086L5.87091 9.67227C6.00864 9.5481 6.18523 9.47566 6.37048 9.46734C6.55573 9.45903 6.73811 9.51536 6.8864 9.62669L9.53226 11.6105C13.6654 7.53495 16.009 5.97094 17.9968 4.77555Z",
    fill: "#2196F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_529_351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCheckActive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "check-active.50fbf40685a9a4c194c70682171a1c97.svg";